import React from 'react'
import './statusLabel.scss'
import { capitalize } from 'lodash'

interface StatusLabelProps {
    status: string
}

const StatusLabel: React.FC<StatusLabelProps> = ({ status }) => {
    return <div className={`status-label ${status}`}>{capitalize(status)}</div>
}

export default StatusLabel
